const TOR_STATUSES = {
  PENDING_APPROVAL: 'pending',
  APPROVED: 'approved',
  DECLINED: 'declined',
  CANCELLED: 'cancelled',
  SEARCH: 'Search',
};

export const TOR_STATUS_LABELS = {
  [TOR_STATUSES.PENDING_APPROVAL]: 'Pending Approval',
  [TOR_STATUSES.APPROVED]: 'Approved',
  [TOR_STATUSES.DECLINED]: 'Declined',
  [TOR_STATUSES.CANCELLED]: 'Cancelled',
};

export const getStatusLabel = (status) => TOR_STATUS_LABELS[status] || status;

export default TOR_STATUSES;
